import type {
  LogicalOperator,
  WorkflowTriggerConditionCreateDTO,
  WorkflowTriggerConditionDTO,
} from '../workflow.types';

export class WorkflowTriggerConditionDTOModel {
  private readonly _dto: WorkflowTriggerConditionDTO;
  private _fieldName: string;
  private _logicalOperator: LogicalOperator | undefined;
  private _value: string;

  constructor(dto: WorkflowTriggerConditionDTO) {
    this._dto = dto;
    this._fieldName = dto.fieldName || '';
    this._logicalOperator = dto.logicalOperator || undefined;
    this._value = dto.value || '';
  }

  get originDTO(): WorkflowTriggerConditionDTO {
    return this._dto;
  }

  get fieldName() {
    return this._fieldName;
  }

  set fieldName(value) {
    this._fieldName = value;
  }

  get id() {
    return this._dto.id || '';
  }

  get logicalOperator() {
    return this._logicalOperator;
  }

  get operator(): 'EQ' {
    return this._dto.operator || 'EQ';
  }

  get value() {
    return this._value;
  }

  get transferWorkflowTriggerConditionCreateDTO(): WorkflowTriggerConditionCreateDTO {
    return {
      fieldName: this._fieldName,
      logicalOperator: this._logicalOperator || undefined,
      operator: this.operator,
      value: this._value,
    };
  }

  setFieldName(name: string) {
    this._fieldName = name;
  }

  setLogicalOperator(logicalOp: LogicalOperator) {
    this._logicalOperator = logicalOp;
  }

  setValue(value: string) {
    this._value = value;
  }
}
